import { Menu } from '@headlessui/react';
import { Plus, ChevronDown, Laptop, KeyRound } from 'lucide-react';

interface Props {
  /** Chamado ao clicar em "Ativo físico". Abre o AtivoFormModal do caller. */
  onNewAtivo: () => void;
  /** Chamado ao clicar em "Software / Licença". Abre o LicencaFormModal. */
  onNewLicenca: () => void;
}

/**
 * Dropdown de "Novo" na aba Listar Ativos.
 *
 * Separa a criação em dois fluxos completamente distintos, cada um com
 * seu próprio formulário — ativo físico e licença de software não
 * compartilham campos suficientes para justificar um form condicional.
 *
 * O componente não sabe onde os modais vivem — recebe callbacks e
 * delega a abertura pro caller (AtivosPage). Assim o estado dos modais
 * fica onde ele importa: junto da lista que precisa refetch após save.
 */
export function NovoAtivoDropdown({ onNewAtivo, onNewLicenca }: Props) {
  return (
    <Menu as="div" className="relative inline-block text-left">
      <Menu.Button className="inline-flex items-center gap-2 rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1">
        <Plus className="h-4 w-4" />
        Novo
        <ChevronDown className="h-4 w-4 opacity-75" />
      </Menu.Button>
      <Menu.Items className="absolute right-0 z-20 mt-1 w-64 origin-top-right rounded-md border border-gray-200 bg-white shadow-lg focus:outline-none">
        <div className="p-1">
          <Menu.Item>
            {({ active }) => (
              <button
                type="button"
                onClick={onNewAtivo}
                className={`flex w-full items-start gap-3 rounded p-3 text-left ${
                  active ? 'bg-blue-50' : ''
                }`}
              >
                <Laptop className="mt-0.5 h-5 w-5 shrink-0 text-gray-500" />
                <div>
                  <p className="text-sm font-medium text-gray-900">Ativo físico</p>
                  <p className="mt-0.5 text-xs text-gray-500">
                    Notebook, monitor, celular, servidor.
                  </p>
                </div>
              </button>
            )}
          </Menu.Item>
          <Menu.Item>
            {({ active }) => (
              <button
                type="button"
                onClick={onNewLicenca}
                className={`flex w-full items-start gap-3 rounded p-3 text-left ${
                  active ? 'bg-blue-50' : ''
                }`}
              >
                <KeyRound className="mt-0.5 h-5 w-5 shrink-0 text-violet-600" />
                <div>
                  <p className="text-sm font-medium text-gray-900">Software / Licença</p>
                  <p className="mt-0.5 text-xs text-gray-500">
                    Adobe, Microsoft, antivírus — com controle de seats e vencimento.
                  </p>
                </div>
              </button>
            )}
          </Menu.Item>
        </div>
      </Menu.Items>
    </Menu>
  );
}
